import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

import SectionBackground from "assets/images/Section.png";
import LaptopMockup from "assets/images/LandlordPropertiesLaptop.png";

export default function LandlordPropertiesCTA({
  id,
  title = "Let's talk about your properties",
  description = "Whether you manage one unit or hundreds, we'll help you streamline maintenance without adding overhead.",
  buttonText = "Contact Us to Learn More",
  buttonLink = "/signup",
}) {
  const navigate = useNavigate();

  return (
    <div id={id} className="w-full">
      <section
        className="relative w-full overflow-hidden bg-[#56C877] py-10 md:py-0 md:min-h-[372px]"
        style={{
          backgroundImage: `url(${SectionBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="relative z-10 mx-auto flex h-full w-full max-w-[1440px] flex-col items-center justify-between gap-8 px-5 pt-10 text-center md:px-12 md:flex-row md:pt-0">
          <div className="flex max-w-[520px] flex-col items-center text-center">
            <h2 className="text-white text-[32px] font-medium leading-tight md:text-[56px] md:leading-[60px]">
              {title}
            </h2>
            <p className="mt-4 max-w-[450px] text-white text-[15px] md:text-[18px] md:leading-[28px]">
              {description}
            </p>
            <button
              type="button"
              onClick={() => navigate(buttonLink)}
              className="homeLanding-button homeLanding-actionButton mt-6"
            >
              {buttonText}
            </button>
          </div>

          <div className="relative z-10 flex w-full max-w-[680px] justify-center md:justify-end md:self-end">
            <img
              src={LaptopMockup}
              alt="Properteasy properties dashboard shown on a laptop"
              className="w-full max-w-[700px] h-auto object-contain md:translate-y-[34px]"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
